import { render, staticRenderFns } from "./DataSourceStockData.vue?vue&type=template&id=20150665&scoped=true&"
import script from "./DataSourceStockData.vue?vue&type=script&lang=js&"
export * from "./DataSourceStockData.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceStockData.vue?vue&type=style&index=0&id=20150665&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20150665",
  null
  
)

export default component.exports